import React from 'react';
import { Typography, Box } from '@mui/material';

function Schedule() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Schedule Management
      </Typography>
      <Typography variant="body1">
        Schedule management functionality coming soon...
      </Typography>
    </Box>
  );
}

export default Schedule; 